import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from "react-i18next";
import styles from './TemplateMsg.module.css'
import { Dropdown, Tabs, Tab } from 'react-bootstrap';
import TemplateMsgItem from './TemplateMsgItem';
import i18next from "i18next";
import { FaFilter } from 'react-icons/fa';

const TemplateMsg = (props) => {
    const [templateSearchInputState, setTemplateSearchInputState] = useState('')
    const [selectedSubject, setSelectedSubject] = useState('');
    const [subjectDropdownOpen, setSubjectDropdownOpen] = useState(false);
    const filterRef = useRef(null);

    const [t] = useTranslation('common')
    const { tempMsgs, templateMessageClickHandler, isLimitedOnlyForWhatsapp, filterCondition } = props
    const drop = props.drop || 'right' //up, right, left
    const whatsappVerifiedTempList = []
    const regularTempMsgList = []
    const lang = i18next.language

    const uniqueSubjects = Array.from(new Set(
        tempMsgs?.flatMap(tempMsg => tempMsg.subjects?.map(s => typeof s === 'string' ? s : s.key) || [])
    )).filter(Boolean);

    useEffect(() => {
        function handleClickOutside(event) {
            if (filterRef.current && !filterRef.current.contains(event.target)) {
                setSubjectDropdownOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    if (tempMsgs?.length > 0) {
        tempMsgs.forEach((tempMsg) => {
            const isMatch = tempMsg.msg.includes(templateSearchInputState);
            const shouldDisplay = filterCondition === 'display' ? tempMsg.display : tempMsg.supportMailingList;

            const subjectKeys = tempMsg.subjects?.map(s => typeof s === 'string' ? s : s.key) || [];
            const matchesSubject = !selectedSubject || subjectKeys.includes(selectedSubject);

            if (!shouldDisplay || !isMatch || !matchesSubject) return;

            // if (!tempMsg.display || !tempMsg.msg.includes(templateSearchInputState)) return
            if (tempMsg.whatsappVerified) {
                whatsappVerifiedTempList.push(<TemplateMsgItem tempMsg={tempMsg} templateMessageClickHandler={templateMessageClickHandler} />)
            }
            else {
                regularTempMsgList.push(<TemplateMsgItem tempMsg={tempMsg} templateMessageClickHandler={templateMessageClickHandler} />)
            }
        })
    }

    const menuHeight = filterCondition === 'display' ? styles.tempMsgsMenuDisplay : styles.tempMsgsMenuMailingList;

    return <Dropdown drop={drop}>{/*drop='right'*/}
        {props.children}
        <Dropdown.Menu className={`${styles['tempMsgsMenu']} ${menuHeight}`}>
            <div className={`${styles['templates-search-container']}`}>
                <input type='text' value={templateSearchInputState} onChange={e => setTemplateSearchInputState(e.target.value)} className={`${styles[`template-search-text-input`]} ${lang === 'en' && 'ltr'}`} placeholder={t('search')} />
                <div className={styles['filter-wrapper']} ref={filterRef}>
                    <div className={styles['filter-button']} onClick={() => setSubjectDropdownOpen(prev => !prev)} title={t('Filter by template subject')}>
                        <FaFilter size={24} className={styles['filter-icon']} />
                    </div>{subjectDropdownOpen && (
                        <div className={styles['custom-subject-dropdown']}>
                            {uniqueSubjects.map(subject => (
                                <div key={subject} className={selectedSubject === subject ? styles['selected-subject'] : ''}
                                    onClick={() => {
                                        setSelectedSubject(subject);
                                        setSubjectDropdownOpen(false);
                                    }}
                                >
                                    {subject === 'general' ? t('general') : subject}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <Tabs
                transition={false}
                id="controlled-tab-example"
                className='cusTabs'
            >
                {!isLimitedOnlyForWhatsapp &&
                    <Tab className='cusTab' eventKey="RegularMsgs" title={t('Regular messages')}>
                        {regularTempMsgList}
                    </Tab>
                }
                <Tab className='cusTab' eventKey="WhatsappVerified" title={t('Approved by WhatsApp')}>
                    {whatsappVerifiedTempList}
                </Tab>

            </Tabs>
        </Dropdown.Menu>
    </Dropdown>
}

export default TemplateMsg